module.exports = __webpack_public_path__ + "static/media/link-logo-cboe.9753e458.png";